import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MagicPenIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 20H20M18 4L6 16M7.846 4.923C7.846 5.433 7.433 5.846 6.923 5.846C6.413 5.846 6 5.433 6 4.923C6 4.413 6.413 4 6.923 4C7.433 4 7.846 4.413 7.846 4.923ZM18 15.077C18 15.587 17.587 16 17.077 16C16.567 16 16.154 15.587 16.154 15.077C16.154 14.567 16.567 14.154 17.077 14.154C17.587 14.154 18 14.567 18 15.077Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

MagicPenIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MagicPenIcon);
